import $ from 'jquery'
import slick from 'slick-carousel'
import LazyLoad from "vanilla-lazyload"
import ScrollMagic from 'scrollmagic'

/* SETUP SLICK
  ----------------------------- */
export const setupSlideshow = (el, type = 'basic') => {
  const $el = $(el);
  const opts = {
    basic: {
      autoplay: true,
      dots: true,
      arrows: false,
      infinite: true,
      autoplaySpeed: 5000,
      speed: 1000,
    },
    threeItem: {
      autoplay: true,
      dots: true,
      arrows: false,
      slidesToShow: 3,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }]
    },
    twoItem: {
      autoplay: true,
      dots: true,
      arrows: false,
      slidesToShow: 2,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }]
    },
    variableWidth: {
      dots: false,
      arrows: false,
      infinite: true,
      centerMode: false,
      variableWidth: false,
      slidesToShow: 4,
    }
  }

  $el.slick(opts[type])
}

/* LAZY LOAD
  ----------------------------- */
export const lazyLoad = () => {
  const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    data_src: "lazy",
  })
}

/* SMOOTH SCROLL
  ----------------------------- */
export const smoothScroll = () => {
  $('a[href*="#"]:not([href="#"]):not([href="#top"])').click(function() {
    const target = $(this.hash)
    $('html, body').animate({ scrollTop: target.offset().top-60 }, 600)
    return false
  })

  $("a[href='#top']").click(function() {
    $("html, body").animate({ scrollTop: 0 }, 800)
    return false
  })
}

/* HEADER ANIMATION
  ----------------------------- */
export const menuOverlay = () => {
  const toggle = $('.header__toggle')
  const bar = $('.header__toggle .bar')
  const overlay = $('.header--offcanvas, .header__inner, .content-area, body')
  const link = $('.header--offcanvas a');
  const header = $('.header--main');

  toggle.on('click', function () {
    overlay.toggleClass('open')
    bar.toggleClass('animate')
    toggle.toggleClass('open')
  })

  link.on('click', function () {
    overlay.removeClass('open')
    bar.removeClass('animate')
    toggle.removeClass('open')
  })

  window.onresize = () => {
    overlay.removeClass('open')
    bar.removeClass('animate')
    toggle.removeClass('open')
  }

  $(window).scroll(function(e) {
    $(document).scrollTop() > 200 ?
      header.addClass('sticky') :
      header.removeClass('sticky')

    this.oldScroll > this.scrollY ?
      header.addClass('sticky-show').removeClass('sticky-hide') :
      header.addClass('sticky-hide').removeClass('sticky-show')
    this.oldScroll = this.scrollY
  })
}

/* FACET RESET AFER PAGE LOAD
  ----------------------------- */
export const facetReset = () => {
  if ($('.fwp-reset').length) {
    $('.fwp-reset').click()
  }

  document.addEventListener('facetwp-refresh', function() {
    $('html, body').animate({ scrollTop: $('#facet-container').offset().top-120 }, 1000)
  })
}


// WEBPACK FOOTER //
// ./src/js/functions.js